import styled from "styled-components";

const Footer = styled.div`
  margin: 10px 0 ;
  text-align: center;

  p {
    font-weight: 600;
    color:#2c2c2c;
    margin: 15px 0;
    line-height: 1.34;
    font-size: 13px;
  }
`

export default Footer